const colors = {
  color1: "linear-gradient(to top, #ff4b5c, #ff8c42)",
  color2: "linear-gradient(to top, #6a11cb, #2575fc)",
  color3: "linear-gradient(to top, #ff9a8b, #ff6a00)",
  color4: "linear-gradient(to top, #2d92d1, #56ccf2)",
  color5: "linear-gradient(to top, #6a9a8e, #0f3443)",
  color6: "linear-gradient(to top, #005a80, #0f3443)",
  color7: "linear-gradient(to top, #4d5aa6, #0f3443)",
  color8: "linear-gradient(to top, #009dae, #0f3443)",
  color9: "linear-gradient(to top, #669999, #0f3443)",
  color10: "linear-gradient(to top, #efc63dff, #4582e3ff)",
};

export default colors;
